import React from 'react';

const StarBurst = ({ color = '#ACE2DF', stroke = '#000', strokeWidth = 2, className = '', style = {} }) => (
  <svg
    className={className}
    style={style}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 618 618"
    aria-hidden="true"
  >
    <path
      vectorEffect="non-scaling-stroke"
      d="M230.601 9.122l66.605 56.55.719.61.651-.682 60.329-63.202 37.845 78.75.409.851.873-.358 80.819-33.2 2.543 87.335.027.944.943.027 87.336 2.543-33.2 80.819-.359.873.851.408 78.75 37.846-63.201 60.328-.682.652.61.719 56.549 66.604-82.275 29.407-.888.317.265.906 24.57 83.846-87.123-6.6-.941-.071-.126.935-11.657 86.591-76.907-41.466-.83-.447-.495.803-45.87 74.363-53.392-69.161-.576-.747-.779.532-72.151 49.277-20.645-84.898-.223-.917-.928.17-85.956 15.67 15.671-85.955.169-.928-.917-.223-84.898-20.646 49.278-72.15.531-.779-.746-.577L2.017 291.4l74.364-45.87.803-.495-.448-.831-41.466-76.906 86.592-11.658.935-.126-.072-.941-6.6-87.122 83.847 24.57.905.265.318-.889 29.406-82.275z"
      stroke={stroke}
      strokeWidth={strokeWidth}
    />
  </svg>
);

export default StarBurst;
